import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Vereins-Pflegeorte gibt es nicht mehr. Pflegestellen liegen unter Meine Pflegestellen. */
export default function TenantLocationDetailRedirect() {
  return <Redirect href={routes.myCareSites} />;
}
